// Бренд сборки: имя, цвет, логотип. Третий слой клиентского контура
// (docs/superpowers/specs/2026-09-03-client-edition-boundary.md): в отличие от права и
// коммерции он не удаляется, а ПОДМЕНЯЕТСЯ — продукт у клиента называется и выглядит
// по-своему.
//
// Отделено от lib/company.js намеренно: там реквизиты юрлица, которые в клиентскую
// сборку не входят вовсе, а имя и цвет нужны и там и там.
export const PRODUCT_NAME = process.env.REACT_APP_PRODUCT_NAME || 'Бит.Ньютон';

// Цвет живёт CSS-переменной, а не классом Tailwind: класс подставляется на сборке и
// зафиксировал бы наш цвет в бандле навсегда. Переменную ставит index.js при
// старте, поэтому смена цвета — это переменная сборки, а не правка 35 мест в коде.
//
// По умолчанию — акцент «Бумаги» (paper.accent в tailwind.config.js). До 28.09.2026
// здесь стоял фиолетовый #782FFF от прежнего оформления: витрина, тарифы, форма
// пробного месяца и подвал были фиолетовыми при малиновом продукте (владелец: «интерфейс
// должен быть единый»). Клиентская сборка по-прежнему задаёт свой цвет переменной.
export const BRAND_COLOR = process.env.REACT_APP_BRAND_COLOR || '#E50071';
// Оттенок для hover. Задаётся отдельно: осветлять цвет вычислением можно, но у чужого
// бренда «светлее на 10%» нередко выходит за его палитру.
export const BRAND_COLOR_HOVER = process.env.REACT_APP_BRAND_COLOR_HOVER || '#cc0066';

// Куда писать, если что-то не работает до входа (отказ входа, отключённая учётка).
// Это бренд, а не реквизит: у клиентской установки поддержка своя, поэтому адрес —
// переменная сборки, как имя и цвет, а не CONTACTS из lib/company.js (тот в on-prem
// не входит вовсе, src/config/no-legal-in-onprem.test.js).
export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL || 'support@1bitai.ru';

// Логотип — файл в public/, а не импорт: так его можно подменить, не пересобирая бандл.
export const LOGO_URL = process.env.REACT_APP_LOGO_URL || '/logo_firstbit_newton.png';

// Ставит цвета в корень документа. Зовётся один раз из index.js до первого рендера.
export function applyBrand() {
  const root = document.documentElement;
  root.style.setProperty('--brand', BRAND_COLOR);
  root.style.setProperty('--brand-hover', BRAND_COLOR_HOVER);
}
